import React, { useEffect, useRef } from "react";
import { create } from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4core from "@amcharts/amcharts4/core";

const DashboardChart = ({ data }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (!chartRef.current) return;

    const chart = create(chartRef.current, am4charts.XYChart);
    chart.data = (data && data.length > 0) ? data : [
      { month: "Jan", value: 0 },
      { month: "Feb", value: 0 },
      { month: "Mar", value: 0 },
      { month: "Apr", value: 0 },
      { month: "May", value: 0 },
      { month: "Jun", value: 0 },
      { month: "Jul", value: 0 },
      { month: "Aug", value: 0 },
      { month: "Sep", value: 0 },
      { month: "Oct", value: 0 },
      { month: "Nov", value: 0 },
      { month: "Dec", value: 0 }
    ];
    chart.logo.disabled = true;

    chart.paddingTop = 10;
    chart.paddingBottom = 10;
    chart.paddingLeft = 0;
    chart.paddingRight = 10;

    const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "month";
    categoryAxis.renderer.minGridDistance = 60;
    categoryAxis.renderer.grid.template.disabled = true;
    categoryAxis.renderer.labels.template.fontSize = 10;
    categoryAxis.renderer.labels.template.fill = am4core.color("#94a3b8");
    categoryAxis.renderer.labels.template.rotation = -35;
    categoryAxis.renderer.labels.template.horizontalCenter = "right";
    categoryAxis.renderer.labels.template.verticalCenter = "middle";
    categoryAxis.renderer.labels.template.truncate = false;
    categoryAxis.renderer.labels.template.wrap = false;
    categoryAxis.renderer.cellStartLocation = 0.05;
    categoryAxis.renderer.cellEndLocation = 0.95;

    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0;
    valueAxis.renderer.grid.template.stroke = am4core.color("#f1f5f9");
    valueAxis.renderer.grid.template.strokeOpacity = 1;
    valueAxis.renderer.labels.template.fontSize = 11;
    valueAxis.renderer.labels.template.fill = am4core.color("#94a3b8");
    valueAxis.renderer.ticks.template.disabled = true;

    const series = chart.series.push(new am4charts.LineSeries());
    series.dataFields.valueY = "value";
    series.dataFields.categoryX = "month";
    series.name = "Revenue";
    series.strokeWidth = 2.5;
    series.stroke = am4core.color("#0d9488");
    series.fill = am4core.color("#0d9488");
    series.fillOpacity = 0.15;
    series.tensionX = 0.8;
    series.minBulletDistance = 15;

    series.tooltipText = "{categoryX}: [bold]₹{valueY}[/]";
    series.tooltip.getFillFromObject = false;
    series.tooltip.background.fill = am4core.color("#1e293b");
    series.tooltip.background.strokeWidth = 0;
    series.tooltip.background.cornerRadius = 6;
    series.tooltip.label.fill = am4core.color("#ffffff");
    series.tooltip.label.fontSize = 11;

    chart.cursor = new am4charts.XYCursor();
    chart.cursor.lineX.disabled = true;
    chart.cursor.lineY.disabled = true;

    const bullet = series.bullets.push(new am4charts.CircleBullet());
    bullet.circle.fill = am4core.color("#0d9488");
    bullet.circle.strokeWidth = 2;
    bullet.circle.stroke = am4core.color("#ffffff");
    bullet.circle.radius = 3;

    return () => {
      chart.dispose();
    };
  }, [data]);

  return <div ref={chartRef} style={{ width: "100%", height: "240px" }}></div>;
};

export default DashboardChart;